import { publicAssetsURL } from '#internal/nuxt/paths';export default publicAssetsURL("/comensal-2-pedido.webp")